// Generated by purs version 0.13.8
"use strict";
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Lens_Internal_Wander = require("../Data.Lens.Internal.Wander/index.js");
var Data_Lens_Setter = require("../Data.Lens.Setter/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Lunarbox_Data_Editor_DataflowFunction = require("../Lunarbox.Data.Editor.DataflowFunction/index.js");
var Lunarbox_Data_Editor_State = require("../Lunarbox.Data.Editor.State/index.js");
var NativeConfig = function (x) {
    return x;
};
var loadNativeConfig = function (v) {
    var loadFunctionData = Data_Lens_Setter.set(Lunarbox_Data_Editor_State["_atFunctionData"](v.name)(Data_Lens_Internal_Wander.wanderFunction))(Data_Maybe.Just.create(v.functionData));
    var loadFunction = Data_Lens_Setter.set(Lunarbox_Data_Editor_State["_function"](v.name)(Data_Lens_Internal_Wander.wanderFunction))(Data_Maybe.Just.create(new Lunarbox_Data_Editor_DataflowFunction.NativeFunction(v.expression)));
    return function ($6) {
        return loadFunction(loadFunctionData($6));
    };
};
var loadNativeConfigs = function (dictFoldable) {
    return Data_Function.flip(Data_Foldable.foldr(dictFoldable)(loadNativeConfig));
};
module.exports = {
    NativeConfig: NativeConfig,
    loadNativeConfig: loadNativeConfig,
    loadNativeConfigs: loadNativeConfigs
};
